
<mat-card appearance="outlined" class="note-card-shell">


  <mat-card-header>
    <!-- <img mat-card-avatar  [src]="'../../assets/img/' + this.Note.PlayerCurrentTeamIcon" />     -->
    
    <table>
      <tr>
        <td>
          @if (this.Note.PlayerCurrentTeamIcon!=null) {
            <img style="max-height: 40px; max-width: 70px;" [src]="('/assets/img/' + this.Note.PlayerCurrentTeamIcon).replace('//','/').toLowerCase()"     >
          }
          @else {
            <mat-icon style="color: darkgray;">article</mat-icon>
          }
        </td>
        <td>
          <a style="font-size: 11px; " class="gamelink" [routerLink]="['/player/details', this.Note.PlayerId]"> 
          {{ this.Note.PlayerLastName}}, {{ this.Note.PlayerFirstName}}
         </a>
        <div style="font-size: 10px; ">
          <span>
            {{this.Note.PositionId | position }}
          </span>
          
           <span>
            {{ this.Note.DateOfBirth | date:'yyyy-MM-dd'}} ({{this.Note.PlayerAgeYear + ' Years ' + this.Note.PlayerAgeMonth + ' Months'}})

          </span>
          <br>
            @if (this.Note.ReportDivision != null && this.Note.ReportTeamName != null) {
              <span>
                {{(this.Note.ReportDivision ) + "/" + this.Note.ReportTeamName}}<br/>
              </span>
            }
            @if (this.Note.ReportDivision === null || this.Note.ReportTeamName === null) {
              <span>
                {{(this.Note.PlayerCurrentDivision) + "/" + this.Note.PlayerCurrentTeam}}<br/>
              </span>
            }

          </div>


        </td>
      </tr>
    </table>



  </mat-card-header>
  <mat-card-content style="margin-bottom: 0px;" >
    


    <div style="font-size: 12px; margin-top: 5px;min-height: 50px;">
    <label style="font-size: 10px; color: darkgray;">Note</label><br/>
      {{this.Note.Text}}
    </div>




    <div style="font-family: verdana,arial,sans-serif; font-size: x-small;  text-align: left; vertical-align: top;  padding: 0; white-space: normal; margin: 0;  ">
    
      
      
      <div style="font-family: Rubik; color: darkgray;text-align: left; vertical-align: top;  padding: 0; white-space: normal; margin: 0;  ">
      <table>
        @if (this.Note.GameText) {
          <tr>
            <td>
              <mat-icon style="font-size: 18px; height: 19px;">sports_hockey</mat-icon>
            </td>
            <td>
              <div style="font-size: 10px;">
            

                <a [routerLink]="['/scouting/gamedetails', this.Note.GameId]" class="gamelink">
                  {{this.Note.GameText}}     <br>
                </a>
                <span>{{this.Note.ReportDivision}} - {{this.Note.GameDate | date:'yyyy-MM-dd'}}</span>
              </div>
            </td>
          </tr>
        }

        <tr>
          <td>

            <mat-icon style="font-size: 18px; height: 19px;"> location_on</mat-icon>
          </td>
          <td>
            <div style="font-size: 10px;">
              {{this.Note.Location}}
            </div>
          </td>
        </tr>
       
        
         @if (this.Note.Source) {
          <tr>
            <td>
              <mat-icon style=" font-size: 18px; height: 18px;"> hearing</mat-icon>
            </td>
            <td>
              <div style="font-size: 10px;">
                {{this.Note.Source}}
              </div>
            </td>
          </tr>
        }
         <tr>
          <td>
            <mat-icon style="font-size: 18px; height: 19px;">person</mat-icon>
          </td>
          <td>
            <div style="font-size: 10px;">{{this.Note.CreatedByLastName}}, {{this.Note.CreatedByFirstName}}  <span style="color: gray;font-size: 10px; color: darkgray;">- {{getTimeAgo()}} ({{this.Note.DateCreated | date:'yyyy-MM-dd HH:mm' }})</span></div>

          </td>
        </tr>

      </table>



    </div>



    </div>


    



  </mat-card-content>
  <!-- <mat-card-actions> -->
    <!--  <button mat-button  (click)="openViewReport(this.Report.ReportId)" >
    <mat-icon style="font-size: 18px; opacity: 0.6;">
      rate_review
    </mat-icon>
    Report
  </button> -->
<!--   <button mat-icon-button style="opacity: 0.6;" (click)="gotoPlayerDetails(this.Note.PlayerId)" >
    <mat-icon>person</mat-icon>
  </button>
  @if (this.Note.IsCreatedByCurrentUser) {
    <button mat-icon-button [routerLink]="['/scouting/editnote', this.Note.PlayerNoteId]" >
      <mat-icon style="font-size: 18px; opacity: 0.6;">
        edit
      </mat-icon>
    </button>
  } -->
  <!--<button mat-button style="opacity: 0.6;" (click)="gotoPlayerDashboard()" ><img style="height: 24px;"   src="../../assets/img/icons8-user-shield-48.png">Player</button>
  <button mat-button style="opacity: 0.6;" >
    <mat-icon style="font-size: 18px; opacity: 0.6;">sports_hockey</mat-icon>
    Game
  </button> -->
<!-- </mat-card-actions> -->
<!--  <mat-card-actions>

<button mat-button style="opacity: 0.6;"  ><img style="height: 24px;"   src="../../assets/img/icons8-user-shield-48.png">Player</button>
<button mat-button style="opacity: 0.6;" >
  <mat-icon style="font-size: 18px; opacity: 0.6;">sports_hockey</mat-icon>
  Game
</button>
</mat-card-actions> -->
</mat-card>
